/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import {
	InnerBlocks,
} from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { generateCustomStyleCode } from '../../../extensions/custom-styles';
import BaseWrapper from '../../../components/base-wrapper';

const ALLOWED_BLOCKS = [ 'core/social-links' ];

const getInnerBlockTemplate = () => {
	return [
		[ 'core/image', {
			url: `${ window.gutenify_block_data.plugin_directory_url }assets/images/profile-pic.jpg`,
			align: false,
		} ],
		[
			'core/column',
			{
				templateLock: 'all',
			},
			[
				[
					'core/heading',
					{
						content: __( 'Jane Doe' ),
						level: 3,
						placeholder: __( 'Title' ),
					},
				],
				[
					'core/heading',
					{
						content: __( 'Founder/ CEO' ),
						level: 5,
						placeholder: __( 'Degination' ),
					},
				],
				[ 'core/paragraph', {
					content: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet est massa. Sed enim massa, mattis at libero nec, bibendum ultricies augue.' ),
					placeholder: __( 'Bio of team member.' ),
				} ],
				[ 'core/social-links' ],
			],
		],
	];
};

class edit extends Component {
	constructor( props ) {
		super( props );
		this.updateTeamMember = this.updateTeamMember.bind( this );
	}

	componentDidMount() {
		const { attributes, setAttributes, clientId } = this.props;
		const { blockAdvanceOptions, isSaved } = attributes;

		let saveIt = false;
		if ( ! isSaved ) {
			setAttributes( { isSaved: true, blockClientId: clientId } );
			saveIt = true;
		}
		generateCustomStyleCode( blockAdvanceOptions, { ...this.props }, saveIt );
	}

	updateTeamMember( data ) {
		const { setAttributes } = this.props;
		setAttributes( {
			...data,
		} );
	}

	render() {
		const { isSelected, clientId, className } = this.props;
		const wrapperClasses = classnames(
			className,
			'wp-block-gutenify-team-member'
		);
		return (
			<div className={ wrapperClasses }>
				<BaseWrapper { ...this.props }>
					{ isSelected && <Inspector { ...this.props } /> }
					<InnerBlocks
						allowedBlocks={ ALLOWED_BLOCKS }
						template={ getInnerBlockTemplate() }
						templateLock="all"
						templateInsertUpdatesSelection={ false }
					/>
				</BaseWrapper>
			</div>
		);
	}
}

export default edit;
